import React from 'react';
import dayjs from 'dayjs';
import type { ApprovalPrintSigner } from '@/services/approval.service';
import { resolvePublicAssetUrl } from '@/config/apiBaseUrl';
import './PrintableApprovalSigners.css';

export interface PrintableApprovalSignersProps {
  signers: ApprovalPrintSigner[];
}

export const PrintableApprovalSigners: React.FC<PrintableApprovalSignersProps> = ({ signers }) => {
  if (!signers?.length) return null;

  return (
    <div className="print-approval-signers">
      <h3 className="print-approval-title">Approvals</h3>
      <div className="print-approval-grid">
        {signers.map((s) => (
          <div key={`${s.step_number}-${s.user.id}`} className="print-approval-cell">
            <div className="print-approval-name">{s.user.full_name}</div>
            {s.user.designation ? (
              <div className="print-approval-designation">{s.user.designation}</div>
            ) : null}
            {s.user.signature_image_url ? (
              <img
                className="print-approval-sig-img"
                src={resolvePublicAssetUrl(s.user.signature_image_url) || ''}
                alt=""
              />
            ) : (
              <div className="print-approval-sig-line" aria-hidden />
            )}
            {s.acted_at ? (
              <div className="print-approval-date">{dayjs(s.acted_at).format('DD-MM-YYYY HH:mm')}</div>
            ) : (
              <div className="print-approval-date print-approval-pending">Pending</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrintableApprovalSigners;
